import { render, staticRenderFns } from "./SetEquivalences.vue?vue&type=template&id=59c0ebba&scoped=true"
import script from "./SetEquivalences.vue?vue&type=script&lang=js"
export * from "./SetEquivalences.vue?vue&type=script&lang=js"
import style0 from "./SetEquivalences.vue?vue&type=style&index=0&id=59c0ebba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c0ebba",
  null
  
)

export default component.exports